import { defineMessages } from 'react-intl';

export default defineMessages({
  scheduleReport: {
    id: 'createScheduledReportModal.scheduleReport',
    defaultMessage: 'Schedule Reports',
  },
  editSchedule: {
    id: 'createScheduledReportModal.editSchedule',
    defaultMessage: 'Edit Schedule',
  },
  cancel: {
    id: 'createScheduledReportModal.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'createScheduledReportModal.save',
    defaultMessage: 'Save',
  },
  saveChanges: {
    id: 'createScheduledReportModal.saveChanges',
    defaultMessage: 'Save Changes',
  },
  delete: {
    id: 'createScheduledReportModal.delete',
    defaultMessage: 'Delete',
  },
  confirmDelete: {
    id: 'createScheduledReportModal.confirmDelete',
    defaultMessage: 'Yes, Delete',
  },
  deleteConfirmTitle: {
    id: 'createScheduledReportModal.deleteConfirmTitle',
    defaultMessage: 'Delete Schedule',
  },
  deleteConfirmMessage: {
    id: 'createScheduledReportModal.deleteConfirmMessage',
    defaultMessage:
      'Are you sure you want to delete this schedule? This action cannot be undone.',
  },
  scheduleSuccess: {
    id: 'createScheduledReportModal.scheduleSuccess',
    defaultMessage:
      'Schedule created successfully. You will receive the report at the configured date and time.',
  },
  scheduleError: {
    id: 'createScheduledReportModal.scheduleError',
    defaultMessage: 'Error scheduling report',
  },
  updateSuccess: {
    id: 'createScheduledReportModal.updateSuccess',
    defaultMessage: 'Schedule updated successfully.',
  },
  updateError: {
    id: 'createScheduledReportModal.updateError',
    defaultMessage: 'Error updating schedule',
  },
  deleteSuccess: {
    id: 'createScheduledReportModal.deleteSuccess',
    defaultMessage: 'Schedule deleted successfully.',
  },
  deleteError: {
    id: 'createScheduledReportModal.deleteError',
    defaultMessage: 'Error deleting schedule',
  },
  startDateInPast: {
    id: 'createScheduledReportModal.startDateInPast',
    defaultMessage:
      'The start date and time must be at least 10 minutes in the future. Please select a later time or a future date.',
  },
  frequency: {
    id: 'createScheduledReportModal.frequency',
    defaultMessage: 'Frequency',
  },
  daily: {
    id: 'createScheduledReportModal.daily',
    defaultMessage: 'Daily',
  },
  weekly: {
    id: 'createScheduledReportModal.weekly',
    defaultMessage: 'Weekly',
  },
  monthly: {
    id: 'createScheduledReportModal.monthly',
    defaultMessage: 'Monthly',
  },
  date: {
    id: 'createScheduledReportModal.date',
    defaultMessage: 'Date',
  },
  time: {
    id: 'createScheduledReportModal.time',
    defaultMessage: 'Time',
  },
  startDate: {
    id: 'createScheduledReportModal.startDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'createScheduledReportModal.endDate',
    defaultMessage: 'End Date',
  },
  deliveryEmails: {
    id: 'createScheduledReportModal.deliveryEmails',
    defaultMessage: 'Delivery Email(s)',
  },
  properties: {
    id: 'createScheduledReportModal.properties',
    defaultMessage: 'Properties',
  },
  propertyGroup: {
    id: 'createScheduledReportModal.propertyGroup',
    defaultMessage: 'Property Group',
  },
  format: {
    id: 'createScheduledReportModal.format',
    defaultMessage: 'Format',
  },
  reportingPeriod: {
    id: 'createScheduledReportModal.reportingPeriod',
    defaultMessage: 'Reporting Period',
  },
  removeDuplicateEmails: {
    id: 'createScheduledReportModal.removeDuplicateEmails',
    defaultMessage: 'Remove duplicate emails to create report',
  },
  rangeMustIncludeWeekday: {
    id: 'createScheduledReportModal.rangeMustIncludeWeekday',
    defaultMessage:
      'The selected date range must include at least one {weekday}.',
  },
  rangeMustIncludeDayOfMonth: {
    id: 'createScheduledReportModal.rangeMustIncludeDayOfMonth',
    defaultMessage:
      '{kind, select, ' +
      'last {The selected date range must include the last day of at least one month.} ' +
      'day {The selected date range must include day {dayOfMonth} of at least one month.} ' +
      'other {}}',
  },
  rangeMustAllowOneCycle: {
    id: 'createScheduledReportModal.rangeMustAllowOneCycle',
    defaultMessage:
      'At least 1 cycle must be completed. End date must be after start date.',
  },
  rangeMustAllowAnyExecution: {
    id: 'createScheduledReportModal.rangeMustAllowAnyExecution',
    defaultMessage:
      'The selected end date does not allow any execution before it. ' +
      'Please pick a later end date or adjust the execution time.',
  },
});
